/* eslint-disable */
export default {
  copy: 'Copia',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
